export default class ContactDetailController {
    /* @ngInject */
    constructor($scope, $state, $stateParams, ApiContacts, ApiCampaigns, ApiTeam, ApiUser, $ionicLoading, $q, MessageBox, $ionicPopup, $filter) {
        this.$ionicLoading = $ionicLoading;
        this.$state = $state;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiContacts = ApiContacts;
        this.ApiTeam = ApiTeam;
        this.ApiUser = ApiUser;
        this.MessageBox = MessageBox;

        this.contactId = $stateParams.contactId;
        this.campaigns = [];
        this.isCustomerContact = $stateParams.isCustomerContact;
        this.loading = [];
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.advindaCount = $stateParams.advindaCount;
        this.customCount = $stateParams.customCount;
        this.preSelectedCampaignIds = [];
        this.translationVisible = false;
        this.addInfoVisible =false;
        this.contact = {};
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
        this.getContact();
        // Load contact from database
   
        this.ApiContacts.getContactExtensionIds(this.contactId, { 'isCustomerContact': this.isCustomerContact }).then((res) => {
            if (res) {
                this.taskParameters = { contactExtensionIds: res, contactId: this.contactId, 'isCustomerContact': this.isCustomerContact };
            } else {
                this.taskParameters = { contactExtensionIds: [this.contactId], contactId: this.contactId, 'isCustomerContact': this.isCustomerContact };
            }
            this.$ionicLoading.hide();
        })
            .catch(() => {
                this.$ionicLoading.hide();
            });

        // Load campaigns from database
        this.ApiCampaigns.getCampaignsMinimal().then((res) => {
            this.campaigns = res;
        })
            .catch(() => {
                this.$ionicLoading.hide();
            });

        this.ApiUser.getUser().then((res) => {
            if (typeof res != 'undefined') {
                this.userGroupId = res.groupId
            }
        });

        this.getPreSelectedCampaignIds();
        this.getTeams();
    }
    getContact(){

        this.ApiContacts.getContact(this.contactId, { 'isCustomerContact': this.isCustomerContact }).then((res) => {
            this.contact = res;
            this.contact.contactInfo.contact.additionalInformation = !this.isCustomerContact && this.contact.contactInfo.advindaContactAdditionalInfo ?
                this.contact.contactInfo.advindaContactAdditionalInfo.additionalInfo : this.contact.contactInfo.contact.additionalInformation

            this.isAddressVisible = this.contact.contactInfo.contact.mailingStreet || this.contact.contactInfo.contact.mailingPostalCode ||
                this.contact.contactInfo.contact.mailingCity || this.contact.contactInfo.contact.mailingState || this.contact.contactInfo.contact.mailingCountry;
            this.isAdditionalAddressVisible = this.contact.contactInfo.contact.additionalAddress || this.contact.contactInfo.contact.additionalZip ||
                this.contact.contactInfo.contact.additionalState || this.contact.contactInfo.contact.additionalCountry;
            this.isAddressTranslationVisible = this.contact.contactInfo.contact.countryTranslated || this.contact.contactInfo.contact.stateTranslated ||
                this.contact.contactInfo.contact.cityTranslated || this.contact.contactInfo.contact.zipTranslated || this.contact.contactInfo.contact.addressTranslated;
            
            this.isContactInfoSectionVisible = this.contact.contactInfo.contact.phone || this.contact.contactInfo.contact.otherPhone ||
            this.contact.contactInfo.contact.mobile || this.contact.contactInfo.contact.privatePhoneNumber || this.contact.contactInfo.contact.fax
            || this.contact.contactInfo.contact.alternativeEmail  || this.contact.contactInfo.contact.email ||  this.contact.contactInfo.contact.additionalInformation;

            this.isBuisnessCardVisible =  this.contact.contactInfo.contact.businessCardInformation || this.contact.contactInfo.contact.businessCardInformationReceivedDate ||
                this.contact.contactInfo.contact.businessCardInformationLastUpdatedDate;
               
            this.hideLoading();

        })
        .catch(() => {
            this.$ionicLoading.hide();
          });

    }

    showLoading() {
        this.loading.push(1);
        this.$ionicLoading.show({ template: '<spinner-advinda></spinner-advinda>' });
    }

    hideLoading() {
        this.loading.pop();
        if (this.loading.length === 0)
            this.$ionicLoading.hide();
    }

    promptContactDelete($event) {
        $event.preventDefault();
        let dialogResult = this.$ionicPopup.confirm({
            title: this.$filter('translate')('DELETE_CONTACT'),
            template: this.$filter('translate')('DELETE_CONTACT_PROMPT')
        });

        dialogResult.then((res) => {
            if (res) {
                this.deleteContact(this.contact);
            }
        });
    }

    deleteContact(contact) {
        this.showLoading();
        this.ApiContacts.deleteContact(contact.contactInfo.contact.id).then((res) => {
            this.hideLoading();
            if (res === null) {
                this.$state.go('contacts', { defaultTab: 'TEAM' }, { reload: true });
            }
        }, function (error) {
            this.hideLoading();
            this.MessageBox.showFailMessage('CONTACT', 'DELETE');
        });
    }

    getPreSelectedCampaignIds() {
        this.ApiContacts.getCampaignIds(this.contactId, { 'isCustomerContact': this.isCustomerContact })
            .then((res) => {
                this.preSelectedCampaignIds = res || [];
            });
    }

    onCommentEntered(comment) {

        this.showLoading();
        if (this.contact.contactInfo.advindaContactAdditionalInfo && this.contact.contactInfo.advindaContactAdditionalInfo.id) {
            this.additionalInfo = {
                additionalInfo: comment,
                contactId: this.contact.contactInfo.advindaContactAdditionalInfo.contactId,
                groupId: this.contact.contactInfo.advindaContactAdditionalInfo.groupId,
                id: this.contact.contactInfo.advindaContactAdditionalInfo.id
            };

            this.ApiContacts.putAdditionalInfo(this.additionalInfo).then((res) => {
                this.getContact();
            }, function () {
                this.hideLoading();
            });
        }
        else {
            this.additionalInfo = {
                'additionalInfo': comment,
                'contactId': this.contactId,
                'groupId': this.userGroupId
            };
            this.ApiContacts.postAdditionalInfo(this.additionalInfo).then((res) => {
                this.getContact();
                

            }, function () {
                this.hideLoading();
            });
        }



    }


    getTeams() {

        this.ApiTeam.getTeams().then((res) => {
            if (typeof res != 'undefined') {
                if (res) {
                    this.translationVisible = res.translationRequired;
                }
            }
        });
    }


}



/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contactDetail.controller.js
 **/